import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RepairFormulaCreateDto } from '@vatos-pas/common';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import {
  RepairFormulaFormValues,
  RepairsSettingsContainer,
} from '../containers';
import { RepairsSettingsForm } from '../components';

const RepairsSettingsCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();
  const {
    formLoading,
    setFormLoading,
    createFormula,
    loadRepairOptions,
  } = RepairsSettingsContainer.useContainer();

  const handleSubmit = useCallback(
    async (values: RepairFormulaFormValues) => {
      setFormLoading(true);
      try {
        const created = await createFormula(values as RepairFormulaCreateDto);
        notify('Element created');
        history.push(`/repair-formula/${created.id}`);
      } catch (error: unknown) {
        console.error('Repair formula create failed:', error);
        notify(
          extractErrorMessage(error, 'Failed to create repair formula'),
          'error',
        );
      } finally {
        setFormLoading(false);
      }
    },
    [createFormula, history, notify, setFormLoading],
  );

  const handleGoBack = useCallback(
    () => history.push('/repair-formula'),
    [history],
  );

  return (
    <Box className={classes.formContainer}>
      <RepairsSettingsForm
        mode="create"
        onSubmit={handleSubmit}
        loading={formLoading}
        onGoBack={handleGoBack}
        loadRepairOptions={loadRepairOptions}
      />
    </Box>
  );
};

export const RepairsSettingsCreate = () => (
  <RepairsSettingsContainer.Provider>
    <RepairsSettingsCreateInner />
  </RepairsSettingsContainer.Provider>
);

const useStyles = makeStyles(theme => ({
  formContainer: {
    position: 'relative',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

export default RepairsSettingsCreate;
